module.exports = __webpack_public_path__ + "static/media/Group3411.260ce88a.svg";